import React from "react";
import {
  FiCalendar,
  FiUser,
  FiFileText,
  FiExternalLink,
  FiMapPin,
} from "react-icons/fi";
import { TbExternalLink } from "react-icons/tb";
import { BiSolidQuoteLeft } from "react-icons/bi";
import { HiOutlineAcademicCap } from "react-icons/hi2";
import CustomButton from "../CustomButton";

function ResearchPaperCard({ paper, onView }) {
  const handleViewClick = () => {
    if (onView) {
      onView(paper);
    }
  };

  // Helper function to get citation badge styles
  const getCitationBadgeStyles = (citations) => {
    if (citations >= 100) {
      return { backgroundColor: "#63D06E" };
    }
    if (citations >= 50) {
      return { backgroundColor: "#ffc107" };
    }
    if (citations >= 10) {
      return { backgroundColor: "#17a2b8" };
    }
    return { backgroundColor: "#adb0b4" };
  };

  return (
    <div
      className="card mb-3 position-relative"
      style={{ borderRadius: "10px" }}
    >
      <div className="card-body p-4">
        <div className="d-flex justify-content-between">
          <h5 className="p3 fw-semibold mb-1">{paper.title}</h5>
          <div>
            <span
              className="d-flex badge rounded-pill"
              style={getCitationBadgeStyles(paper.citations || 0)}
            >
              {paper.citations || 0} Citations
            </span>
          </div>
        </div>

        {paper.authors && (
          <h6 className="mb-2 text-muted p5">{paper.authors}</h6>
        )}

        {paper.summary && <p className="p4 text-secondary">{paper.summary}</p>}

        <div className="mb-3">
          <div className="row mb-2">
            {paper.year && (
              <div className="col-12 col-md-4 mb-2 mb-md-0 p-0">
                <div className="d-flex align-items-start">
                  <FiCalendar className="me-2 mt-1" style={{ flexShrink: 0 }} />
                  <div>
                    <span className="p4 fw-semibold pe-2">Year:</span>
                    <span>{paper.year}</span>
                  </div>
                </div>
              </div>
            )}
            {paper.journal && (
              <div className="col-12 col-md-8 mb-2 mb-md-0 p-0">
                <div className="d-flex align-items-start">
                  <HiOutlineAcademicCap
                    className="me-2 mt-1"
                    style={{ flexShrink: 0 }}
                  />
                  <div>
                    <span className="p4 fw-semibold pe-2">Journal:</span>
                    <span
                      className="d-inline-block"
                      style={{ wordWrap: "break-word" }}
                    >
                      {paper.journal}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {paper.institutions && paper.institutions.length > 0 && (
            <div className="row">
              <div className="col-12 p-0">
                <div className="d-flex align-items-start">
                  <FiMapPin className="me-2 mt-1" style={{ flexShrink: 0 }} />
                  <div>
                    <span className="p4 fw-semibold pe-2">Institutions:</span>
                    <span
                      className="d-inline-block"
                      style={{ wordWrap: "break-word" }}
                    >
                      {Array.isArray(paper.institutions)
                        ? paper.institutions.slice(0, 3).join(", ")
                        : paper.institutions}
                      {Array.isArray(paper.institutions) &&
                        paper.institutions.length > 3 &&
                        ` +${paper.institutions.length - 3} more`}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end mt-2">
          <CustomButton
            variant="outline"
            className="btn-sm px-3 py-2 d-flex align-items-center justify-content-center gap-2"
            onClick={handleViewClick}
            disabled={!paper.fulltext_link}
          >
            <TbExternalLink size={18} />
            <span className="fw-normal">
              {paper.fulltext_link ? "View Paper" : "Not Available"}
            </span>
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default ResearchPaperCard;
